import { createBrowserRouter, RouteObject } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary';
import RootLayout from '../components/Layouts/RootLayout/RootLayout';
import loan_routes from './loan';
import { registered_routes } from './registered';
import unregistered_routes from './unregister';

function toArray<T>(item: T | T[]): T[] {
  return Array.isArray(item) ? item : [item];
}

const allRoutes = [...toArray(registered_routes), ...toArray(unregistered_routes), ...loan_routes];

// Wrap all routes with RootLayout to maintain hooks across route changes
const routesWithRootLayout: RouteObject = {
  path: '/',
  element: <RootLayout />,
  children: allRoutes,
  errorElement: <ErrorBoundary />,
};

const router = createBrowserRouter([routesWithRootLayout]);

export default router;
